import { IoChevronBack, IoCameraOutline } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useRef,useState, useEffect, } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Analytics } from '../compornents/Analytics';
import OrderStatus from '../compornents/OrderStatus';
import { useModal } from 'react-hooks-use-modal';
import { Post, PostFile } from '../compornents/Post';
import { toast } from 'react-toastify';
import { TailSpin } from 'react-loading-icons';



export const Order = () => {
  // order_id取得
  let location = useLocation();
  const params = useParams();
  const order_id = params.order_id;
  // console.log(location.state);
  const [order, setOrder] = useState(location.state === null?[]:location.state.order);
  const [comments, setComments] = useState([]);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [ImageModal, openImageModal, closeImageModal] = useModal('root', {
    // preventScroll: true,
    focusTrapOptions : {
       clickOutsideDeactivates: true,
    },
  });
  const [expandedOptions, setExpandedOptions] = useState({});

  // ファイル入力のリファレンスを作成
  const fileInputRef = useRef(null);
  // 戻る
  const back = () => {
    navigate(-1);
  };

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });

  // 画像を選択したら即送信（LINEのように選んだ写真がそのまま会話に表示される）
  const onPickFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    openLoadingModal();
    try {
      const files = [{ file: f, key_name: 'file' }];
      const r = await PostFile('post', '/order/create_comment_image.php', { order_id }, files);
      if (r.result === 1) setComments(r.comments);
      else toast.error(r.error_message);
    } finally {
      closeLoadingModal();
    }
  };

  // テキスト送信
  const sendComment = async () => {
    if (message.trim() === '') return;
    openLoadingModal();
    try {
      const r = await Post('post', '/order/create_comment.php', { order_id, message });
      if (r.result === 1) { setComments(r.comments); setMessage(''); }
      else toast.error(r.error_message);
    } finally {
      closeLoadingModal();
    }
  };



  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // 注文情報取得
    async function getOrder() {
      openLoadingModal();
      const request_data = {
        'order_id' : order_id,
      }
      // post
      const response_data = await Post('post', '/order/detail.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {
        setOrder(response_data.order);
        setComments(response_data.comments);
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    }
    getOrder();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id]);

  return (
    <div className="App">
      <div className="Order">
        <Analytics title="注文詳細" />
        <div className="toolbar">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            注文詳細
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="mt-3 mb-5">
          <div className="order_body mb-3">
            <div className="order_header mb-2">
              <OrderStatus
                order={order}
              />
              <div className="order_date">
                ・{order.order_date}
              </div>
            </div>
            <div className="h4 mb-2">
              ご注文内容
            </div>
            <div className="content mb-4 mt-4">
              <div className="row mb-2">
                <div className="col-8">
                  {order.item_name}
                </div>
                <div className="col-4 text-right">
                  ￥{Number(order.kin).toLocaleString()}
                </div>
              </div>
              {order.options !== undefined && order.options.length>0 && (
                <>
                  {order.options.map(option =>
                    <>
                      <div className="row mb-2">
                        <div className="col-8">
                          {option.images?.length > 0 ? (
                            <>
                              <span
                                className="text-primary"
                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                onClick={() =>
                                  setExpandedOptions(prev => ({
                                    ...prev,
                                    [option.id]: !prev[option.id],
                                  }))
                                }
                              >
                                {option.option_name}
                              </span> x {option.suu}
                            </>
                          ) : (
                            <>
                              {option.option_name} x {option.suu}
                            </>
                          )}
                        </div>
                        <div className="col-4 text-right">
                          ¥{Number(option.sum_kin).toLocaleString()}
                        </div>
                      </div>
                      {option.images?.length > 0 && (
                        <div className="">
                          <div
                            className={`option-image-list ${expandedOptions[option.id] ? 'open' : ''}`}
                          >
                            <div className="row mt-2 mb-2">
                              {option.images.map((image,key) =>
                                <div className="col-3" key={key}>
                                  <img
                                    src={image.img}
                                    className="OptionImage"
                                    alt="Option"
                                    onClick={() => {
                                      setSelectedImage(image.img);
                                      openImageModal();
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              <div className="row pt-2 mb-2 border-top">
                <div className="col-8">
                  小計
                </div>
                <div className="col-4 text-right">
                  ￥{Number(Number(order.kin)+Number(order.option_kin)).toLocaleString()}
                </div>
              </div>
              {order.nebi !== "0" && (
                <div className="row">
                  <div className="col-8">
                    クーポン
                  </div>
                  <div className="col-4 mb-2 text-right">
                    -￥{Number(order.nebi).toLocaleString()}
                  </div>
                </div>
              )}
              {Number(order.photo_nebi) > 0 && (
                <div className="row">
                  <div className="col-8">
                    撮影割引
                  </div>
                  <div className="col-4 mb-2 text-right">
                    -￥{Number(order.photo_nebi).toLocaleString()}
                  </div>
                </div>
              )}
              <div className="row mb-2 border-bottom">
                <div className="col-8">
                  Uber配達手数料
                </div>
                <div className="col-4 mb-2   text-right">
                  ￥{Number(order.uber_fee).toLocaleString()}
                </div>
              </div>
              <div className="row">
                <div className="col-6 h5">
                  合計
                </div>
                <div className="col-6 text-right h4">
                  ￥{Number(order.goukei).toLocaleString()}
                </div>
              </div>
            </div>
            {/* <div className="h6 mb-1">お客様の住所</div>
            <div className="mb-3">
              {order.pref + order.add1 + order.add2}<br />
              {order.add3}{order.room}
            </div> */}
            <div className="h6 mb-2" style={{ fontWeight: 600 }}>メッセージ</div>

            {/* チャット（古い順・上から下） */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '2px 0' }}>
              {comments.length > 0 ? [...comments].sort((a, b) => Number(a.id) - Number(b.id)).map(comment => {
                const t = Number(comment.type);
                const mine = t === 1 || t === 3; // 顧客=右
                const isImage = t === 2 || t === 3;
                const sender = mine ? (order.name || 'あなた') : (comment.staff_name || 'スタッフ');
                return (
                  <div key={comment.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start' }}>
                    <div style={{ maxWidth: '82%' }}>
                      <div style={{ fontSize: 11, color: '#999', marginBottom: 2, textAlign: mine ? 'right' : 'left' }}>
                        {sender}{!mine && Number(comment.read_suu) === 0 && <span className="text-danger"> New!</span>}
                      </div>
                      <div style={{
                        background: mine ? '#ffe9a8' : '#fff',
                        border: `1px solid ${mine ? '#f3d77a' : '#e5e7eb'}`,
                        borderRadius: 14, padding: isImage ? 6 : '8px 12px',
                        borderTopRightRadius: mine ? 4 : 14, borderTopLeftRadius: mine ? 14 : 4,
                      }}>
                        {isImage
                          ? <img src={comment.message} alt="画像" onClick={() => { setSelectedImage(comment.message); openImageModal(); }}
                              style={{ maxWidth: 200, maxHeight: 200, borderRadius: 8, display: 'block', cursor: 'pointer' }} />
                          : <span style={{ whiteSpace: 'pre-wrap' }}>{comment.message}</span>}
                      </div>
                      <div style={{ fontSize: 10, color: '#bbb', marginTop: 2, textAlign: mine ? 'right' : 'left' }}>{comment.insert_name}</div>
                    </div>
                  </div>
                );
              }) : (<div className="text-center text-gray-dark">メッセージはありません</div>)}
            </div>

            {/* 入力欄（最下部・LINE風）。📷は選択すると即送信、テキストは送信ボタンで送信。 */}
            <div style={{ marginTop: 14, borderTop: '1px solid #eee', paddingTop: 10 }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                <label className="div_btn" title="写真を送る" style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 22, border: '1px solid #e5e7eb', background: '#fafafa', cursor: 'pointer' }}>
                  <IoCameraOutline style={{ fontSize: 22, color: '#666' }} />
                  <input type="file" accept="image/*" onChange={onPickFile} ref={fileInputRef} style={{ display: 'none' }} />
                </label>
                <textarea
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="メッセージを入力"
                  rows={1}
                  style={{ flex: 1, resize: 'none', borderRadius: 18, border: '1px solid #ddd', padding: '10px 14px', fontSize: 15, lineHeight: 1.4, maxHeight: 120 }}
                />
                <button onClick={sendComment} disabled={message.trim() === ''}
                  className="btn btn-yellow" style={{ flex: '0 0 auto', borderRadius: 22, height: 44, padding: '0 18px', fontWeight: 600 }}>
                  送信
                </button>
              </div>
              <div className="text-gray-dark" style={{ fontSize: 11, marginTop: 4 }}>📷 写真は選ぶとすぐ送信されます</div>
            </div>
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
        <ImageModal>
          <div className="modal rounded text-center p-3 position-relative" style={{ maxWidth: '90vw' }}>
            <button
              onClick={closeImageModal}
              className="closeModalBtn"
              aria-label="閉じる"
            >
              ×
            </button>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="拡大画像"
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '10px',
                  maxHeight: '80vh',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>
        </ImageModal>

        <Tabbar menu="orders" />
      </div>

    </div>
  );
}
